
export const routes = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}/supplier-messages`,
        name: `${prefix}.supplier-messages.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.supplier-messages.index`,
                PageDescription: "Supplier Configurations: Supplier messages",
            },
        },
    },
];
